<template>
  <div>
    <div class="location-nav">
      <!--	<md-button class="md-sm md-info" @click="openLocationBox">Add Photos to a new Location</md-button>-->
      <div class="placeholder" />
      <md-button class="md-sm md-warning" @click="goBackToAll" v-if="showLocationItem">Go Back to List</md-button>
    </div>
    <div v-if="showLocationList">
      <div class="gpr-info locations" v-for="location in locations" :key="location.id" >
        <div class="top-row" @click="goToLocation(location.id)">
          <template v-if="gpr_report == {}">
            <h5>Location: {{location.name}}</h5> <small>{{location.created_at | formatDate}}</small>
          </template>
          <template v-else>
            <h5>Location: ATS#{{ats_data.ats_number}}-{{location.ats_location_number}}</h5> <small>{{location.updated_at | formatDate}}</small>
          </template>
        </div>
        <p>Created By: {{location.user}}</p>
      </div>
    </div>
    <div v-if="showLocationItem">
      <div class="gpr-info locations location locations-tab-files" >
        <div class="top-row"><h5>Location: {{currentLocation.name}}</h5> <small>{{currentLocation.created_at | formatDate}}</small> </div>
        <p>Files: </p>

      <div style="width: 100%" class="files-display" v-if="currentLocation.files.length">
        <div class="files-display-item"  v-for="f in currentLocation.files" :key="f.filename">
          <!--	  <md-button md-ripple="false" @click="removeFile(f.url, index)" class="remove"><md-icon>close</md-icon></md-button> -->
          <!-- -->

          <div style="display: flex; flex-direction: column; align-items:center;justify-content:center;">
            <md-icon style="width: 140px; height: 70px"><img style="width: 140px; height: 80px" :src="f.url" /></md-icon>
            <md-button
              class="md-sm md-info"
              v-on:click="openLightbox(`${currentLocation.id}-${f.filename}`)"
              >Open Image</md-button
            >
            <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 140px">{{f.filename}}</p>
            <!--	  <p>Created by: {{f.userName}}</p> -->
          </div>
        </div>
      </div>


        <h6>Summary</h6>
        <p>{{ currentLocation.survey_summary }}</p>
        <h6>Other Notes</h6>
        <p>{{ currentLocation.summary_notes }}</p>
        <h6>Barcode Number</h6>
        <p>{{ currentLocation.barcode_number }}</p>

<!--	<p v-if='currentLocation.files' v-for='file in currentLocation.files'><a :href='file.url'>{{file.filename}}</a></p> -->
        <md-button class="md-sm md-danger" @click="deleteLocation(currentLocation.id)" v-if="gprAccess">Delete Location</md-button>
        <md-button class="md-sm md-danger" @click="editLocation(currentLocation.id)" v-if="gprAccess">Edit Location</md-button>
      </div>
    </div>

    <div v-if="editLocationItem">
      <div class="location-nav">
        <!--	<md-button class="md-sm md-info" @click="openLocationBox">Add Photos to a new Location</md-button>-->
        <div class="placeholder" />
        <md-button class="md-sm md-warning" @click="goBackToAll" v-if="editLocationItem" >Go Back to List</md-button>
      </div>
        <div class="md-layout-item md-size-100 report-section ">
          <md-field>
            <label class="upload-image">Upload Images</label>
            <md-file
              v-model="currentLocation.imgPlaceholder"
              @md-change="getFiles($event)"
              multiple
              accept="image/*"
              required
            />
          </md-field>
          <div
            class="files-display"
            v-if="currentLocation.files && currentLocation.files.length"
          >
            <div
              class="files-display-item"
              v-for="f in currentLocation.files"
              :key="f.name"
            >
              <div class="fdi-wrap">
                <md-icon
                  class="remove"
                  v-on:click.native="removeFile(f)"
                  >close</md-icon
                >
                <img class="fdi-img" :src="f.url" />
                <md-button class="md-sm md-info" v-on:click="openPic(f.url)"
                  >Open Image</md-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-size-100 survey-section edit-location">
          <h5>SafeCore GPR Survey Location Summary</h5>
          <md-divider />
          <p class="survey-des">
            *Select GPR data collection and marking tasks performed at this
            location
          </p>
          <md-field class="mt-2 summary-field">
            <label for="summaryType">GPR Tech Marking Options:</label>
            <div class="d-flex task-lists">
              <md-button :class="{ 'md-info': !showAllTasks }" @click="showTaskAll()"
                >{{
                  showAllTasks ? "Select All Tasks" : "Deselect All Tasks"
                }}
              </md-button>
              <div
                class="sum-list-item"
                v-for="(item, index) in summaryType"
                v-bind:key="index"
              >
                <md-button
                  :class="{ 'md-info': item.show }"
                  @click="showTask(index)"
                  >{{ item.category }}</md-button
                >
              </div>
            </div>
          </md-field>

          <md-field class="mt-2 summary-field">
            <!-- <md-button
              class="select-tasks md-info"
              @click="clearSummary()"
              v-if="selectedItems.length"
              >Select Tasks Performed</md-button
            > -->
            <md-select
              ref="selectDropdown"
              v-model="currentLocation.summaries"
              name="summaries"
              id="summaries"
              class="selected-tasks"
              placeholder="Select Tasks Performed"
              multiple
              required
            >
              <md-option
                v-for="(item, index) in selectedItems"
                v-bind:key="index"
                v-bind:class="getCategoryLabel(item)"
                :value="item"
                :disabled="
                  item == 'SafeCore GPR Tech Standard Tasks' ||
                  item == 'SafeCore GPR Tech Stencil Marking Options' ||
                  item ==
                    '1”-12” Depth of Targets Stencil & Tape Marking Options' ||
                  item ==
                    'SafeCore GPR Tech Tolerance Zone Marking Options' ||
                  item == 'SafeCore GPR Tech Tape Marking Options' ||
                  item ==
                    'GPR Tech Slab-on-Grade Stencil Marking Options' ||
                  item == 'SafeCore GPR Tech Optional Marking Methods'
                "
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
          <div class="summaries-list">
            <div
              class="sum-list-item"
              v-for="item in currentLocation.summaries"
              v-bind:key="item"
            >
              <p>{{ item }}</p>
              <md-icon
                v-on:click.native="removeItem(item, 'summary')"
                >close</md-icon
              >
              <div class="xtra" />
            </div>
          </div>

          <md-field class="other-notes summary-field">
            <label
              >Other Notes: Add additional location specific information as
              required</label
            >
            <md-input
              v-model="currentLocation.summary_notes"
              type="text"
            ></md-input>
          </md-field>
          <md-field class="summary-field">
            <label>SafeCore Barcode Number</label>
            <md-input
              v-model="currentLocation.barcode_number"
              type="text"
            ></md-input>
          </md-field>
          <md-button class="md-sm md-info" @click="showBarcodeScanner"
            >Scan Barcode In</md-button
          >

          <div class="dialog-wrapper">
            <md-dialog :md-active.sync="showDialog">
              <div class="title-top md-dialog-title">
                <h4>Scan your barcode</h4>
                <md-icon v-on:click.native="showBarcodeScanner"
                  >close</md-icon
                >
              </div>
              <BarcodeScannerPopover
                v-on:getBarcode="saveBarcodeNumber"
                v-bind:locationIndex="currentLocation.id"
              />
            </md-dialog>
          </div>
        </div>
        <p class="saving-notes ml-20">
          The information for this GPR survey location will save when you
          proceed to add a location, return to a previous location or save
          as final location. You may return to review and edit this location
          prior to finalizing the SafeCore GPR Survey report if required.
        </p>
        <md-card-actions md-alignment="right">
          <md-button class="md-sm md-danger md-xlarge-size-20 ml-20" @click="saveLocation(currentLocation.id)">Save Location</md-button>
        </md-card-actions>
    </div>
    <div class="dialog-wrapper add-location">
      <md-dialog :md-active.sync="showLBox">
        <md-dialog-title>Add A New Location</md-dialog-title>
        <LocationAdd
          v-bind:projectId="projectId"
          v-bind:locationsLength="locations.length"
          v-on:childToParent="addAndClose"
        />
      </md-dialog>
    </div>
    <LightBox
      :showLightBox="showbox"
      :media="images"
      :key="index"
      :startAt="startAt"
      @closed="handleLightboxClosed"
    />
  </div>
</template>
<script>
  import { LocationAdd } from "@/pages/Dashboard/ProjectPages/Components/LocationsTab/Components";
  import BarcodeScannerPopover from "@/pages/Dashboard/ProjectPages/Components/BarcodeScannerPopover.vue";
  import moment from 'moment';
  import api from "@/api";
  import LightBox from "vue-image-lightbox";

  export default {
    components: {
      LocationAdd,
      BarcodeScannerPopover,
      LightBox
    },
    props: ['ats_data', 'locations', 'projectId', 'gpr_report', 'location_id'],
    data() {
      return {
        showLBox: false,
        showLocationList: true,
        showLocationItem: false,
        editLocationItem: false,
        currentLocation: {},
        images: [],
        showbox: false,
        index: -1,
        startAt: 0,
        summaryType: [
          {
            category: "Standard",
            items: [
              "SafeCore GPR Tech Standard Tasks",
              "RSSI: Reviewed SafeCore Standard stencils and ink and SafeCore Standard marking tape application methods and marking options with authorized representative.  ",
              'ATSI: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" “GPR SURVEY AREA” CORNER / PERIMETER stencils.',
              'ATST: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" white marking tape.',
              "PCQ80LS: Performed a Proceq GP8000 GPR Line Scan and marked targets. ",
              "PCQ88LS: Performed a Proceq GP8800 GPR Line Scan and marked targets. ",
              "PCQ80GS: Performed a 2'X2' Proceq GP8000 Grid Scan and marked targets ",
              "PCQ88LS: Performed a 2'X2' Proceq GP8800 Grid Scan and marked targets. ",
              "HPS10LS: Performed a Hilti PS1000 Line Scan and marked targets.",
              "HPS10GS: Performed a 2'X2' Hilti PS1000 Grid Scan and marked targets. ",
              "AQR: Applied SafeCore ATS Location specific QR code label.",
              'GT1.5: Marked GPR Targets 1.5" wide as authorized.',
              'GT2: Marked GPR Targets 2" wide as authorized. ',
              "NOGPRT: Marked No GPR Targets detected in ATS Survey area.",
              "ANCHR:  Marked GPR Target embedment to clear for anchor installation.",
            ],
            show: false,
          },
          {
            category: "Stencil",
            items: [
              "SafeCore GPR Tech Stencil Marking Options",
              "NSCZ: Marked areas inaccessible to the GPR scanner (due to wall or obstruction) with SafeCore “NO SCAN ZONE” stencils and permanent ink.",
              "TBPAN: Marked approximate location of top and bottom of corrugated pan deck with SafeCore black “TOP OF PAN DECK” and red “BOTTOM OF PAN DECK” stencils as instructed.",
              "TBT: Marked Approximate Location of Top and Bottom of Targets as directed. ",
              "GPRT: Marked GPR target embedment anomalies with SafeCore “GPR TARGET” stencils and black permanent ink.",
              "OBS: Marked GPR target embedment anomalies with SafeCore “OBSTRUCTION” (///////////////) stencils and black permanent ink. ",
              "COND: Marked GPR target embedment’s perceived to be a conduit with SafeCore “CONDUIT” stencils and red permanent ink. ",
              "LP: Marked Live Power target embedment as detected by the scanners Electromagnetic (EM) sensor with SafeCore “LIVE POWER” stencils and red permanent ink. ",
              "PT: Marked GPR target embedment perceived to be a PT cable with SafeCore “PT CABLE” stencils and red permanent ink.",
              "CL: Marked core locations w/ SafeCore -Center Line Core Stencils and green ink upon completion of concrete imaging as directed.",
              "NTD: Marked “NO GPR TARGETS DETECTED” stencil and green ink in areas where no targets could be detected. ",
              "ANCHR:  Marked GPR Target embedment to clear for anchor installation ",
              "CMPS: Marked GPR survey area with SafeCore Compass stencil to assist in orientation ",
              "NCL1”: Marked GPR survey area with NO CORE LAYOUT WITHIN 1” OF MARKED TARGETS ",
              "NCL1.5”: Marked GPR survey area with NO CORE LAYOUT WITHIN 1.5” OF MARKED TARGETS",
              "NCL2”: Marked GPR survey area with NO CORE LAYOUT WITHIN 2” OF MARKED TARGETS",
            ],
            show: false,
          },
          {
            category: "Depths",
            items: [
              "1”-12” Depth of Targets Stencil & Tape Marking Options",
              "MADTS1”: Marked approximate +/- depth of marked targets @ 1”",
              "MADTS2”: Marked approximate +/- depth of marked targets @ 2”",
              "MADTS3”: Marked approximate +/- depth of marked targets @ 3”",
              "MADTS4”: Marked approximate +/- depth of marked targets @ 4”",
              "MADTS5”: Marked approximate +/- depth of marked targets @ 5”",
              "MADTS6”: Marked approximate +/- depth of marked targets @ 6”",
              "MADTS7”: Marked approximate +/- depth of marked targets @ 7”",
              "MADTS8”: Marked approximate +/- depth of marked targets @ 8”",
              "MADTS9”: Marked approximate +/- depth of marked targets @ 9”",
              "MADTS10”: Marked approximate +/- depth of marked targets @10”",
              "MADTS11”: Marked approximate +/- depth of marked targets @11”",
              "MADTS12”: Marked approximate +/- depth of marked targets @12”",
            ],
            show: false,
          },
          {
            category: "Tolerance Zone",
            items: [
              "SafeCore GPR Tech Tolerance Zone Marking Options",
              "GT4.5TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 4.5” wide Tolerance Zone Stencil as directed by Authorized Representative",
              "GT5TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 5” wide Tolerance Zone Stencil as directed by Authorized Representative",
              "CD4.5TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 4.5” wide Tolerance Zone Stencil as directed by Authorized Representative ",
              "CD5TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 5” wide Tolerance Zone Stencil as directed by Authorized Representative ",
              "PT4.5TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 4.5” wide Tolerance Zone Stencil as directed by Authorized Representative ",
              "PT5TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 5” wide Tolerance Zone Stencil as directed by Authorized Representative",
              "LP4.5TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with “LIVE POWER”4.5” wide Tolerance Zone Stencil as directed by Authorized Representative",
              "LP5TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with SafeCore “LIVE POWER” 5” wide Tolerance Zone Stencil as directed by Authorized Representative",
            ],
            show: false,
          },
          {
            category: "Tape",
            items: [
              "SafeCore GPR Tech Tape Marking Options",
              'ATST: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" white marking tape',
              "GPRTT: Marked GPR target embedment anomalies with SafeCore 2” wide black “GPR TARGET” tape",
              "RBRT: Marked GPR target embedment perceived to be rebar through data collected from facility with SafeCore 2” wide black “REBAR” tape",
              "CONDT: Marked GPR target embedment perceived to be a conduit with SafeCore 2” wide red “CONDUIT” tape",
              "LPT: Marked live power GPR target embedment as detected by the scanners Electromagnetic (EM) sensor with SafeCore 2” wide red “LIVE POWER” tape",
              "PTT: Marked GPR target embedment perceived to be a PT Cable with 2” wide SafeCore red “PT CABLE” tape",
              "NSBT: Marked “NO SAWCUT BEYOND THIS LINE” tolerance zone with SafeCore 2” wide sawcut tolerance zone tape.",
              "NCLBT: Marked “NO CORE LAYOUT” tolerance zone with SafeCore 2” wide core drill layout tolerance zone tape.",
              "TPDT: Marked “TOP OF PAN DECK” with 2” wide SafeCore black tape",
              "BPDT:  Marked “BOTTOM OF PAN DECK” with 2” wide SafeCore red tape.",
              "NTDS:  Applied green “NO GPR TARGETS DETECTED” sticker in areas where no targets could be detected.",
              "BPTA: Applied Blue Painters Tape prior to sensitive surfaces prior to SafeCore tape applications. ",
            ],
            show: false,
          },
          {
            category: "Slab on Grade",
            items: [
              "GPR Tech Slab-on-Grade Stencil Marking Options",
              'SOGATS: Identified / Marked Perimeter of "ATS" (Authorized to Scan) slab on grade locations with SafeCore "ATS" “GPR SURVEY AREA” slab on grade corner and perimeter stencils & permanent ink',
              "SOGWM: Marked “WIRE MESH LOCATED THROUGHOUT” slab-on-grade where applicable",
              'SOG3: Marked slab on grade GPR Targets 3" wide as authorized ',
              'SOGC12: Marked slab on grade target embedment’s perceived to be a conduit with SafeCore 3" wide “CONDUIT” / 12" wide "No Sawcut beyond this line" Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGC18: Marked slab on grade target embedment’s perceived to be a conduit with SafeCore 3" wide “CONDUIT” / 18" wide "NO SAWCUT BEYOND THIS LINE" Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGC24: Marked Slab on Grade Target embedment’s perceived to be a conduit with SafeCore 3" wide “CONDUIT” / 24" wide " NO SAWCUT BEYOND THIS LINE Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGGT12: Marked Slab on Grade Target anomalies 3" wide with GPR TARGET / 12" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGGT18: Marked Slab on Grade Target anomalies 3" wide with GPR TARGET / 18" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGGT24: Marked Slab on Grade Targets anomalies 3" wide with GPR TARGET / 24" wide " NO SAWCUT BEYOND THIS LINE” Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGLP12: Marked “Live Power” Slab on Grade Targets 3" wide with LIVE POWER / 12" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGLP18: Marked “Live Power” Slab on Grade Targets 3" wide with LIVE POWER / 18" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
              'SOGLP24: Marked “Live Power” Slab on Grade Targets 3" wide with LIVE POWER / 24" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
            ],
            show: false,
          },
          {
            category: "Options",
            items: [
              "SafeCore GPR Tech Optional Marking Methods",
              "GTPM: Marked GPR targets in permanent marker",
              "GTSP: Marked GPR targets with spray paint",
              "GTCP: Marked GPR targets with crayon / pencil ",
              "GTCED: Marked targets with concrete etching device",
              "GTRBI: Marked GPR Targets with SafeCore Rulers and Black Permanent Ink / Markers",
              "GTRRI: Marked GPR Targets with SafeCore Rulers and Red Permanent Ink / Markers",
              "CPX10: Marked Center Line of Drill Bit Entry Position & Exit Position w/Hilti PX-10 Trans pointer as authorized.",
              "HPS10GS44: Performed a 4’x4' Hilti PS1000 Grid Scan and marked targets.",
              "GSSIGS: Performed GSSI Grid Scan and market targets",
              "GSSILS: Performed a GSSI Line Scan and marked targets",
              "CONQGS: Performed Conquest Grid Scan and marked targets",
              "CONQLS: Performed a Conquest Line Scan and marked targets",
              "MALAGS: Performed Mala Grid Scan and marked targets",
              "MALALS: Performed a Mala Line Scan and marked targets",
            ],
            show: false,
          },
        ],
        showAllTasks: true,
        showDialog: false,
        deleteImages: [],
      }
    },
    methods: {
      handleLightboxClosed() {
        console.log('close box')
      },
      openLightbox(key) {
        const selectedImage = this.images.find((x) => x.id === key);
        // console.log('this.startAt',  this.startAt, selectedImage.fileIndex)
        let fileIndex = selectedImage.fileIndex
        // if(fileIndex == this.startAt){
        //   console.log('same')
        //   fileIndex = fileIndex == this.images.length - 1 ? fileIndex - 1 : fileIndex + 1
        //   console.log('after index',  fileIndex)
        // }
        this.startAt = fileIndex;
        this.index = fileIndex
        this.showbox = true;
      },
      openLocationBox() {
        this.showLBox = !this.showLBox;
      },
      goToLocation(id) {
        var loc = this.locations.filter((l) => l.id == id)
        if (loc[0]){
          loc[0].summaries = loc[0].survey_summary.split(";");
          this.currentLocation = loc[0];
          this.showLocationList = false;
          this.showLocationItem = true;
          this.setImages(this.currentLocation)
        }
      },
      goBackToAll(){
        this.currentLocation = {};
        this.showLocationList = true;
        this.showLocationItem = false;
        this.editLocationItem = false;
      },
      addAndClose(location){
        this.locations.push(location);
        this.showLBox = false;
      },
      deleteLocation(location) {
        //delete from back and optimistic
        if (confirm(`Are you sure you want to delete this location?`)) {
          var data = {
            location_id: location,
            project_id: this.projectId
          }
          api.deleteLocation(data).then((response) => {
            var index = this.locations.findIndex((l) => l.id = location);
            this.locations.splice(index, 1);
            if (this.showLocationItem) {
              this.showLocationList = true;
              this.showLocationItem = false;
            }
          })
        }
      },
      editLocation(location){
        this.editLocationItem = true;
        this.showLocationItem = false;
        console.log('edit location')
      },
      getFiles(filesList) {
        var formData = new FormData();
        var locationId = this.currentLocation.id;
        /** If the location exists, use the existing 'addFiletoLocation'
         *  apply the return 'data' into 'this.locations' */
        if (locationId) {
          const file = filesList[0]
          // filesList.forEach((file) => {
            formData.append("file[]", file);
          // });
          api.addFileToLocation(locationId, formData).then(({ data }) => {
            this.currentLocation.files = data;
            this.setImages(this.currentLocation)
          });
        } 
      },
      removeFile(item) {
        if (confirm(`Are you sure you want to delete this image?`)) {
          this.deleteImages.push(item.img_id)
          // const newLocations = this.locations.map((l) => ({ ...l }));
          this.currentLocation.files = this.currentLocation.files.filter(
            (f) => f.url !== item.url
          );
        }
        // this.locations = newLocations;
        // if (this.filesToUpload.length) {
        //   this.filesToUpload = this.filesToUpload.filter(
        //     (f) => f.name !== item.filename
        //   );
        // }
      },
      openPic(url) {
        window.open(url, "_blank");
      },
      showTaskAll() {
        this.summaryType.forEach((type) => {
          type.show = this.showAllTasks;
        });
        this.showAllTasks = !this.showAllTasks;
      },
      showTask(index) {
        this.summaryType.forEach((type) => {
          type.show = false;
        });
        this.summaryType[index].show = !this.summaryType[index].show;
        const showSelect = this.$refs.selectDropdown.showSelect;
        if (!showSelect) {
          this.$refs.selectDropdown.showSelect = true;
        }
      },
      clearSummary() {
        this.$nextTick(() => {
          console.log('selectDropdown', this.$refs.selectDropdown)
          const selectBox = this.$refs.selectDropdown.$el;
          selectBox.querySelector(".md-select-value").click();
        });
      },
      getCategoryLabel(item) {
        // Find the category based on the selected item
        const category = this.summaryType.find((type) =>
          type.items.includes(item)
        );
        // Return the category label if found
        if (category) {
          return category.category;
        }
        // Return a default label if category is not found
        return "Unknown Category";
      },
      removeItem(item, type) {
        if (type === "summary") {
          var sIndex = this.currentLocation.summaries.findIndex(
            (i) => i == item
          );
          this.currentLocation.summaries.splice(sIndex, 1);
        }
      },
      showBarcodeScanner() {
        this.showDialog = !this.showDialog;
      },
      saveBarcodeNumber(data) {
        this.showDialog = !this.showDialog;
        this.locations[data.index].barcode_number = data.code;
      },
      saveLocation(id){
        var data = {
          id: this.currentLocation.id,
          project_id: this.projectId,
          survey_summary: this.currentLocation.summaries,
          summary_notes: this.currentLocation.summary_notes,
          barcode_number: this.currentLocation.barcode_number,
          deleteImages: this.deleteImages
        }
        api.updateLocation({ location: data }).then((response) => {
          this.notifyVue("Location has been saved", "success");
          return true;
        }).catch((err) => {
          console.log(err);
          this.locationHasErrors = true;
          // this.locationErrors = err;
          return false;
        });
      },
      notifyVue(message, color) {
        this.$notify({
          timeout: 2500,
          message: message,
          horizontalAlign: "left",
          verticalAlign: "top",
          type: color,
        });
      },
      updateCurrentLocation(locationId) {
        // Find the currentLocation in locations based on locationId
        if (locationId && this.locations) {
          this.currentLocation = this.locations.find(location => location.id == locationId);
          this.showLocationItem = true
          this.showLocationList = false
          this.setImages(this.currentLocation)
        } else {
          this.currentLocation = null; // Set currentLocation to null if no location found
        }
      },
      setImages(currentLocation){
        var findex  = 0
        this.index = -1
        this.images = []
        currentLocation.files.forEach((file) => {
          file.srcset = file.url;
          file.src = file.url;
          file.thumb = file.url;
          file.img_id = file.id;
          const key = `${currentLocation.id}-${file.filename}`;
          file.id = key;
          file.caption = key;
          file.fileIndex = findex;
          findex = findex + 1;
          this.images.push(file);
        });
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    },
    computed: {
      selectedItems() {
        const itemsToShow = this.summaryType
          .filter((type) => type.show) // Filter based on the `show` property
          .flatMap((type) => type.items);

        return itemsToShow;
      },
      gprAccess(){
        return this.$store.state.user.gpr_access;
      }
    },
     created() {
      // Initialize currentLocation based on initial location_id and locations
      console.log('this location_id', this.location_id)
      this.location_id && this.updateCurrentLocation(this.location_id);
    },
  }
</script>
<style lang="scss">
  @media (min-width: 768px) {
    .locations-tab-files .files-display{
      min-height: 140px;
    }
  }
</style>

<!-- <md-icon class="delete-location" @click="deleteLocation(currentLocation.id)">cancel</md-icon> -->
